"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const urls_1 = require("../../lib/urls");
const helpers_1 = require("../../lib/helpers");
// dont have Next.js? no problem.
// eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
const Link = urls_1.optionalModule(() => require('next/link').default);
/* Handles creating the <a href/> around the component which provides an href. */
const A = react_1.forwardRef((props, ref) => {
    const { href, internal, shallow, children } = props;
    const url = typeof href === 'string' ? href : href === null || href === void 0 ? void 0 : href.href;
    let linkProps = helpers_1.usePrimitiveProps(Object.assign(Object.assign({}, props), { className: classnames_1.default(internal ? 'j-ai' : 'j-a', (props === null || props === void 0 ? void 0 : props.className)) }));
    // can pass object to href to allow prop drilling on the <a>
    if (href && typeof href !== 'string') {
        linkProps = Object.assign(Object.assign(Object.assign({}, linkProps), href), { className: classnames_1.default(linkProps.className, href.className) });
    }
    else {
        // spreadPrimitiveProps doesnt allow href
        linkProps.href = href;
    }
    // Want to use A customly without a href
    if (!url) {
        return (react_1.default.createElement("a", Object.assign({}, linkProps, { ref: ref }), children));
    }
    return (react_1.default.createElement(Link, { legacyBehavior: true, href: url, shallow: shallow },
        react_1.default.createElement("a", Object.assign({}, linkProps, { ref: ref }), children)));
});
exports.default = A;
